module.exports = __webpack_public_path__ + "static/QualityWorksLogo-582c30d370e16ccf60b0a78a25ff70c0.jpg";